<script lang="ts">
  import Data from "../../components/Data.svelte";
  import { formatNumber } from "../../helpers/string";
  import { ethereum } from "../../store/ethereum";
  import { getContext } from "svelte";
  import ConnectModal from "../../components/modals/ConnectModal.svelte";
  import NftStakingModal from "../../components/modals/NFTStakingModal.svelte";
  import { nftStakingContract, tokenContract } from "../../helpers/contracts";
  import ErrorModal from "../../components/modals/ErrorModal.svelte";
  import TransactionModal from "../../components/modals/TransactionModal.svelte";
  import NFTBugModal from "../../components/modals/NFTBugModal.svelte";

  import { formatEther } from "@ethersproject/units";
  import type { Signer } from "@ethersproject/abstract-signer";
  const { open, close } = getContext("simple-modal");

  let rewardRate = 0;
  let earned = 0;
  $: connected = $ethereum.signer != undefined;
  $: getBalances($ethereum.signer);
  let loading = false;
  let staked = 0;
  let totalStaked = 0;
  let collection = [];

  const connectFirst = () => {
    open(ConnectModal, {
      message:
        "You must connect your wallet before staking. Set you wallet's network to Ethereum.",
    });
  };

  const delay = (sec: number) => {
    return new Promise<void>((resolve) => {
      setTimeout(resolve, 1000 * sec);
    });
  };

  const getBalances = async (s: Signer) => {
    if (s == null) return;
    const _stakingContract = nftStakingContract($ethereum.chainId).connect(
      $ethereum.signer
    );

    try {
      const stakedBalance = await _stakingContract.balanceOf($ethereum.address);
      staked = parseInt(stakedBalance.toString());
    } catch (err) {
      staked = 0;
    }

    await delay(0.1);

    try {
      const _collection = await _stakingContract.getTokensOf($ethereum.address);
      collection = _collection.map((c) => `#${c.toString()}`);
    } catch (err) {
      console.error(err);
      collection = [];
    }

    await delay(0.1);

    try {
      const earnedBalance = await _stakingContract.earned($ethereum.address);
      earned = parseFloat(formatEther(earnedBalance));
    } catch (err) {
      earned = 0;
    }

    await delay(0.1);

    try {
      const _totalStaked = await _stakingContract.totalSupply();
      const _rewardRate = await _stakingContract.rewardRate();
      rewardRate = parseFloat(formatEther(_rewardRate));
      totalStaked = parseFloat(_totalStaked.toString());
    } catch (err) {
      console.error("NFT STAKING", err);
      rewardRate = 0;
      totalStaked = 0;
    }
  };

  const openStakingModal = () => {
    open(NftStakingModal, {});
  };

  const awaitTx = async (res: any, msg: string) => {
    open(TransactionModal, {
      message: msg,
      details: `TxHash: ${res.hash}`,
      hash: res.hash,
    });
    await res.wait();
    close();
    return;
  };

  const handleTxError = (err: any) => {
    try {
      close();
    } catch {
      console.log("nothing to close");
    }

    let msg = err.toString();
    if (err.message && err.code)
      msg = `code: ${err.code}\nmessage: ${err.message}`;

    open(ErrorModal, { message: "Transaction Failed", details: msg });
    console.error(err);
  };

  const claimAndExit = async () => {
    if (!connected) return connectFirst();
    if ($ethereum.signer == undefined) return;
    loading = true;

    try {
      // const gas = await nftStakingContract($ethereum.chainId)
      //   .connect($ethereum.signer)
      //   .estimateGas.exit();

      // console.log(gas.toNumber());
      // const gasLimit = Math.max(gas.toNumber() + 5000, 100000);

      const res = await nftStakingContract($ethereum.chainId)
        .connect($ethereum.signer)
        .exit({ gasLimit: `${275000 + 75000 * staked}` });
      // .exit({ gasLimit: gasLimit.toString() });

      await awaitTx(res, "Unstaking all NFTs and claiming rewards...");
    } catch (err) {
      handleTxError(err);
    }

    loading = false;
  };

  const claim = async () => {
    if (!connected) return connectFirst();
    if ($ethereum.signer == undefined) return;
    loading = true;

    try {
      const res = await nftStakingContract($ethereum.chainId)
        .connect($ethereum.signer)
        .getReward();
      
        await awaitTx(res, "claiming rewards...");
    } catch (err) {
      handleTxError(err);
    }

    loading = false;
  };
</script>


  <div class="col-lg-4 col-md-6 col-sm-12">
    <div class="stakig_card_top">
    <img src={`/img/images/doe.svg`} alt="icon"/>
    <p>NFT Staking</p>
  </div>
  <div class="stakig_card_bottom">
    <div class="row">
      <div class="col-6">
        <span>Rewards Per NFT</span>
        <p>{formatNumber((rewardRate * 86400) / totalStaked, 2)} $DOE per day</p>
      </div>
      <div class="col-6">
        <span>Staked</span>
        {#if staked < 1}
        <p>Not Staked</p>
        {:else}
        <p>{staked} NFTs <br /> <small>{collection.join(", ")}</small></p>
        {/if}
      </div>
      <div class="col-6">
        <span>Earned</span>
        <p>{formatNumber(earned, 4)} $DOE</p>
      </div>
    </div>
    <div class="stake-warning">
      <h2>
        <i class="fas fa-exclamation-triangle" />
        Caution: <br/>
        NFT staking rewards bug.
      </h2>
      <button class="btn btn-primary stake-warning-button" on:click={() => open(NFTBugModal, {})}> Learn More </button>
    </div>
    {#if !connected}
    <button class="connect_common_btn" on:click={connectFirst}>
      Connect Wallet
    </button>
  {:else}
    <button
      class="connect_common_btn"
      on:click={openStakingModal}
      disabled={loading || true}
    >
      Stake NFTs (Disabled)
    </button>

    <button
      class="connect_common_btn red_btn"
      on:click={claim}
      disabled={loading}
    >
      Claim
    </button>

    <button
      class="connect_common_btn red_btn"
      on:click={claimAndExit}
      disabled={loading}
    >
      Unstake all NFTs
    </button>
  {/if}
    
  </div>
  </div>

  



<style>
.connect_common_btn{
  font-size:20px;
  font-weight:600;
}
  .stake-card {
    cursor: default;
    max-width: 100%;
    padding: 20px;
    border-radius: 30px;
    background-color: var(--button-color);
    color: var(--button-text-color);
    transition: transform 0.5s ease;
    width: 400px;
    font-size: 0.8rem;
    margin-bottom: 20px;
    margin-right: 10px;
  }

  .stake-card .stake-image {
    width: 50px;
    padding: 10px;
    margin-top: -50px;
    background-color: var(--button-color);
    border-radius: 100px;
  }

  .stake-card .stake-image img {
    width: 100%;
  }

  .stake-card:hover {
    z-index: 10;
    transform: scale(1.05);
  }

  .flex {
    justify-content: space-between;
  }

  .stake-info {
    margin-right: 10px;
  }

  .btn-large {
    margin-top: 20px;
    padding: 20px 30px;
    width: 100%;
    transition: transform 0.3s ease;
    flex-basis: 50%;
  }

  .btn-large:hover {
    transform: scale(1.02);
  }

  h2 {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
    font-size: 25px;
  }

  small {
    opacity: 0.5;
  }

  a {
    color: var(--accent-color);
  }

  .stake-info {
    width: 100%;
    text-align: center !important;
  }

  @media screen and (max-width: 700px) {
    .stake-info {
      text-align: center !important;
    }
  }

  .stake-warning {
    padding: 10px;
    color: black;
    background-color: #FAB747;
    border-radius: 10px;
    border: 1px solid rgb(184, 135, 0);
    margin: 20px auto;
    text-align: center;
  }

  .stake-warning-button {
    color: black;
    background-color: rgb(184, 135, 0);
  }

  .stake-warning h2 {
    font-size: 1rem;
  }

</style>
